import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { unset } from 'lodash';

interface AIGenerationState {
  [componentId: string]: unknown;
}

const initialState: AIGenerationState = {};

const aiGenerationSlice = createSlice({
  name: 'aiGeneration',
  initialState,
  reducers: {
    setState: (
      state: AIGenerationState,
      action: PayloadAction<{
        componentId: string;
        value?: unknown;
        updater?: (prevValue: unknown) => unknown;
      }>,
    ) => {
      const { componentId, value, updater } = action.payload;

      if (!updater && value === undefined) {
        return;
      }

      if (updater) {
        const currentValue = state[componentId];
        const newState = updater(currentValue);
        state[componentId] = newState;
      } else {
        state[componentId] = value;
      }
    },
    resetState: (
      state: AIGenerationState,
      action: PayloadAction<{ componentId: string; path?: string }>,
    ) => {
      const { componentId, path } = action.payload;

      if (path && state[componentId]) {
        // Removes the property from the object using the specified path
        unset(state[componentId], path);
        return;
      }

      delete state[componentId];
    },
    clearAllStates: () => initialState,
  },
});

export const { setState, resetState, clearAllStates } =
  aiGenerationSlice.actions;

export const { reducer } = aiGenerationSlice;
